package com.rosario.juridico.repositories

import com.rosario.juridico.getPersistedLong
import com.rosario.juridico.persistLong
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Repositorio para gestionar las preferencias del usuario de forma multiplataforma.
 * Utiliza la capa de persistencia nativa definida en Platform.kt (SharedPreferences en Android, 
 * UserDefaults en iOS y LocalStorage en Web).
 */
class PreferencesRepository {
    companion object {
        private const val KEY_LAST_VERSION_NOVEDADES_SEEN = "last_version_novedades_seen"
    }

    private val _lastVersionSeen = MutableStateFlow(getPersistedLong(KEY_LAST_VERSION_NOVEDADES_SEEN).toInt())
    val lastVersionSeen: StateFlow<Int> = _lastVersionSeen.asStateFlow()

    fun saveLastVersionSeen(versionCode: Int) {
        persistLong(KEY_LAST_VERSION_NOVEDADES_SEEN, versionCode.toLong())
        _lastVersionSeen.value = versionCode
    }
}
